import React from 'react';
import { Lesson, LessonType, User } from '../types';
import ReflectionSection from '../components/ReflectionSection';
import PostureLesson from '../components/PostureLesson';

interface LessonDetailPageProps {
  lesson: Lesson;
  user: User | null;
  navigate: (view: string) => void;
}

const LessonDetailPage: React.FC<LessonDetailPageProps> = ({ lesson, user }) => {

  const renderMedia = () => {
    switch (lesson.type) {
      case LessonType.Video:
        return (
          <div className="aspect-w-16 aspect-h-9 rounded-3xl overflow-hidden shadow-lg">
            <iframe 
              src={lesson.media_url} 
              title={lesson.title} 
              frameBorder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              className="w-full h-full"
            ></iframe>
          </div>
        );
      case LessonType.Audio:
        return (
          <div className="bg-white/80 p-6 rounded-3xl shadow-lg border border-white/50 flex flex-col items-center">
            <h3 className="text-2xl font-bold mb-4">{lesson.title}</h3>
            <audio controls className="w-full">
              <source src={lesson.media_url} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        );
      default:
        return <p>Media type not supported.</p>;
    }
  };

  const renderLessonContent = () => {
    if (lesson.slug === 'kroppsholdning-pust') {
      return <PostureLesson />;
    }
    return renderMedia();
  };

  return (
    <div className="container mx-auto max-w-3xl">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">{lesson.title}</h1>
        <p className="text-stone-600 text-lg">{lesson.summary}</p>
      </div>

      <div className="mb-12">
        {renderLessonContent()}
      </div>

      <ReflectionSection user={user} lessonSlug={lesson.slug} />
    </div>
  );
};

export default LessonDetailPage;